import type { FilterOptions } from "@/lib/comics";

interface Props {
  options: FilterOptions;
  onChange: (patch: Partial<FilterOptions>) => void;
  onReset: () => void;
  statusList: string[];
  regionList: string[];
  yearList: number[];
}

const SORT_ITEMS = [
  { key: "latest", label: "最新更新" },
  { key: "hot", label: "最热人气" },
  { key: "score", label: "评分优先" },
];

function FilterRow({
  label,
  items,
  value,
  onPick,
}: {
  label: string;
  items: { key: string; label: string }[];
  value: string;
  onPick: (key: string) => void;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 py-2.5 border-b hairline last:border-b-0">
      <span className="w-[64px] shrink-0 text-xs text-foreground-500">{label}</span>
      <div className="flex flex-wrap items-center gap-1.5">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onPick(item.key)}
            className={`h-8 px-3 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
              value === item.key
                ? "bg-accent-500 text-background-950 font-medium"
                : "bg-background-900/70 border hairline text-foreground-300 hover:border-accent-500/40 hover:text-accent-300"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({ options, onChange, onReset, statusList, regionList, yearList }: Props) {
  return (
    <section aria-label="筛选条件" className="rounded-lg border hairline bg-background-900/60 px-4 py-1">
      <FilterRow
        label="状态"
        items={statusList.map((s) => ({ key: s, label: s }))}
        value={options.status || "全部"}
        onPick={(key) => onChange({ status: key })}
      />
      <FilterRow
        label="地区"
        items={regionList.map((s) => ({ key: s, label: s }))}
        value={options.region || "全部"}
        onPick={(key) => onChange({ region: key })}
      />
      <FilterRow
        label="年份"
        items={[{ key: "全部", label: "全部" }, ...yearList.map((y) => ({ key: String(y), label: String(y) }))]}
        value={options.year || "全部"}
        onPick={(key) => onChange({ year: key })}
      />
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 py-2.5">
        <span className="w-[64px] shrink-0 text-xs text-foreground-500">排序</span>
        <div className="flex flex-wrap items-center gap-1.5">
          {SORT_ITEMS.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => onChange({ sort: item.key })}
              className={`h-8 px-3 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1 ${
                (options.sort || "latest") === item.key
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-900/70 border hairline text-foreground-300 hover:border-primary-400/50"
              }`}
            >
              <i className="ri-sort-desc text-[13px]" />
              {item.label}
            </button>
          ))}
          <button
            type="button"
            onClick={onReset}
            className="h-8 px-3 rounded-md text-xs border border-background-600/70 text-foreground-300 hover:border-accent-500/50 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap ml-auto"
          >
            重置筛选
          </button>
        </div>
      </div>
    </section>
  );
}